import React from "react";

interface ButtonGroupOption {
  value: string;
  label: string;
}

interface ButtonGroupProps {
  label?: string;
  options: ButtonGroupOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
  required?: boolean;
}

export default function ButtonGroup({
  label,
  options,
  value,
  onChange,
  className = "",
  disabled = false,
  required = false,
}: ButtonGroupProps) {
  const hasLabel = label !== undefined;
  return (
    <div className={`relative ${className}`}>
      {/* Label - 속성 존재 시에만 영역 생성 */}
      {hasLabel && (
        <div className="h-6 mb-1">
          <label className="block text-base font-normal text-[#414651]">
            {required && <span className="text-red-500 mr-1">*</span>}
            {label}
          </label>
        </div>
      )}

      {/* Button Group */}
      <div className="inline-flex items-stretch">
        {options.map((option, index) => {
          const isSelected = value === option.value;
          const isFirst = index === 0;
          const isLast = index === options.length - 1;

          return (
            <button
              key={option.value}
              type="button"
              onClick={() => !disabled && onChange(option.value)}
              disabled={disabled}
              className={`
                px-[30px] py-2 text-base leading-normal
                flex items-center justify-center
                focus:outline-none
                ${isFirst ? "rounded-l-md" : ""}
                ${isLast ? "rounded-r-md" : ""}
                ${!isFirst ? "-ml-px" : ""}

                ${
                  isSelected
                    ? disabled
                      ? "bg-gray-400 text-white font-bold border border-gray-400"
                      : "bg-[#1E380B] text-white font-bold border border-[#1E380B] z-10"
                    : disabled
                      ? "bg-gray-100 text-gray-400 font-normal border border-gray-300"
                      : "bg-white text-[#333] font-normal border border-[#CCCCCC] hover:bg-gray-50"
                }

                ${disabled ? "cursor-not-allowed" : "cursor-pointer"}
              `}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

// 사용 예시를 위한 추가 컴포넌트
export function DisplaySelectionGroup({
  value,
  onChange,
  className = "",
  disabled = false,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
}) {
  const options = [
    { value: "all", label: "전체" },
    { value: "shipped", label: "출고" },
    { value: "not_shipped", label: "미출고" },
  ];

  return <ButtonGroup options={options} value={value} onChange={onChange} className={className} disabled={disabled} />;
}

export function OrderTypeGroup({
  value,
  onChange,
  className = "",
  disabled = false,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
}) {
  const options = [
    { value: "all", label: "전체" },
    { value: "web_order", label: "화주WEB 주문" },
  ];

  return <ButtonGroup options={options} value={value} onChange={onChange} className={className} disabled={disabled} />;
}
